import React, { useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import BrandsCarousel from '../components/BrandsCarousel';
import AdditionalServices from '../components/AdditionalServices';
import About from '../components/About';
import InsuranceCarousel from '../components/InsuranceCarousel';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
import Reviews from '../components/Reviews';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Header />
      <Hero />
      <Services />
      <BrandsCarousel />
      <AdditionalServices />
      <About />
      <InsuranceCarousel />
      <FAQ />
      <Contact />
      <Reviews />
      <Footer />
    </div>
  );
};

export default Home;
